$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('#loader').fadeOut(500, function () {
			$(this).remove();
		});
	}, 300);

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * run on load and whenever necessary, for example, after an ajax call
		 * elements: pass the class of the elements to be lazy loaded (e.g. .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else {//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	/* function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash); */

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	$("a.nav-menu-open-icon").on("click", function (e) {
		blockScroll(1);
	});

	$("a.nav-menu-close").on("click", function (e) {
		blockScroll(0);
	});

	$(".slider-main_component").each(function (index) {
		let loopMode = false;
		if ($(this).attr("loop-mode") === "true") {
			loopMode = true;
		}
		let sliderDuration = 300;
		if ($(this).attr("slider-duration") !== undefined) {
			sliderDuration = +$(this).attr("slider-duration");
		}
		const swiperSlider = new Swiper($(this).find(".swiper.is-slider")[0], {
			speed: 1000, // initial speed
			autoHeight: false,
			loop: true,
			loopPreventsSliding: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 32,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			breakpoints: {
				320: { spaceBetween: 16 },
				480: { spaceBetween: 24 },
				991: { spaceBetween: 48 }
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperTestimonials = new Swiper($(this).find(".swiper.is-highlight")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 32,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			breakpoints: {
				320: { spaceBetween: 16 },
				480: { spaceBetween: 16 },
				991: { spaceBetween: 16 }
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-highlight")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet is-highlight",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperStories = new Swiper($(this).find(".swiper.is-stories")[0], {
			speed: 1500,
			autoHeight: false,
			//loop: true,
			centeredSlides: true,
			slideToClickedSlide: false,
			slidesPerView: 'auto',
			spaceBetween: 32,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			breakpoints: {
				320: {
					spaceBetween: 16
				},
				480: {
					spaceBetween: 24
				},
				991: {
					spaceBetween: 32
				}
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: true,
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperIndustryDetails = new Swiper($(this).find(".swiper.is-industry-detail")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 8,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
		});
		const swiper2col = new Swiper($(this).find(".swiper.is-2col-options")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-2col-options")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet is-highlight",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperTeam = new Swiper($(this).find(".swiper.is-team")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-team")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet is-highlight",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperTimeline = new Swiper($(this).find(".swiper.is-timeline")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 0,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperSolutions = new Swiper($(this).find(".swiper.is-solutions")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-solutions")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperLarge = new Swiper($(this).find(".swiper.is-large-slider")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-large-slider")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperHeaderSlider = new Swiper($(this).find(".swiper.is-slider-header")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-slider-header")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperTable = new Swiper($(this).find(".swiper.is-table")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-leadership")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperOfferings = new Swiper($(this).find(".swiper.is-offerings")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-leadership")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
		const swiperLeadership = new Swiper($(this).find(".swiper.is-leadership")[0], {
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper.is-leadership")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet is-highlight",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
	});


	// copy sub sub menus
	$('#sub-menus-list').on('mouseenter', '.submenu-link', function () {
		// Highlight the hovered item
		$('#sub-menus-list').find('.is-active').removeClass('is-active');
		$(this).addClass('is-active');
		// Copy its submenu content
		var copy = $(this).find('.sub-sub-menu-list-container').html();
		$('#sub-menu-container').html(copy);
	});

	$('#sub-menus-list').on('mouseleave', '.submenu-link', function () {
		// Optional: remove active class and clear submenu content
		$(this).removeClass('is-active');
		$('#sub-menu-container').empty(); // or use .html('') if you prefer
	});

	if ($('.select-accordion-parent').length) {
		if ($(window).width() > 767) {
			$('.select-accordion').each(function () {
				var width = $(this).width();
				$(this).parent().width(width);
				$(this).css('width', '100%');
				$(this).find('.select-dropdown-options').css('display', 'none');
			});
		}
		$('.select-accordion-top').on('click', function () {
			$(this).toggleClass('is-open');
		});
		$('body').on('click', function (e) {
			if (!$(e.currentTarget).hasClass('select-accordion-top')) {
				$('.select-accordion-top').each(function () {
					if ($(this).hasClass('is-open')) {
						$(this).trigger('click');
					}
				});
			}
		});
	}

	$('body').on('click', '.list-grid-view-button', function () {
		const $buttons = $('.list-grid-view-button');
		const isGrid = $buttons.index(this) === 0;

		// Toggle active button
		$buttons.removeClass('is-active');
		$(this).addClass('is-active');

		// Change classes in main containers
		const $listingGrids = $('.listing-grid');
		const $listingGridsProducts = $('.product-complementary-card-top');

		if (isGrid) {
			$listingGrids.removeClass('is-list');
			$listingGridsProducts.removeClass('is-list');
			$('body').attr('data-list-view', 'grid');
			Cookies.set('netatwork_list_view', 'grid', { expires: 360 });
		} else {
			$listingGrids.addClass('is-list');
			$listingGridsProducts.addClass('is-list');
			$('body').attr('data-list-view', 'list');
			Cookies.set('netatwork_list_view', 'list', { expires: 360 });
		}
	});

	$('.search-reset').on('click', function () {
		$(this).parent().find('.search-input').val('');
	});

	$('.children').each(function () {
		const $children = $(this);
		let hasVisible = false;

		$children.find('.comment-item').each(function () {
			if (!$(this).find('.comment-hidden').length) {
				hasVisible = true;
				return false;
			}
		});

		if (!hasVisible) {
			$children.hide();
		}
	});

	$('body').on('click', '#show-all-comments', function () {
		$('.comment-hidden').removeClass('comment-hidden').hide().slideDown(200);

		$('.children').each(function () {
			const $children = $(this);
			let hasVisible = false;

			$children.find('.comment-item').each(function () {
				if (!$(this).find('.comment-hidden').length) {
					hasVisible = true;
					return false;
				}
			});

			if (hasVisible) {
				$children.slideDown(200);
			}
		});

		$(this).hide();
	});

	//comments
	const $select = $('#comments-sort-select');

	if ($select.length) {
		$select.on('change', function () {
			const selected = $(this).val();
			const params = new URLSearchParams(window.location.search);

			// Adjustment to send 'DESC' for newest and 'ASC' for oldest
			if (selected === 'newest') {
				params.set('comment_order', 'DESC');
			} else if (selected === 'oldest') {
				params.set('comment_order', 'ASC');
			}

			window.location.search = params.toString();
		});

		// Initialize dropdown according to the URL parameter
		const urlParams = new URLSearchParams(window.location.search);
		const order = urlParams.get('comment_order');

		if (order === 'ASC') {
			$select.val('oldest');
		} else {
			// default para newest (DESC)
			$select.val('newest');
		}
	}

	// Function to update the state of the anchor-links section
	function updateAnchorLinksClass() {
		const notificationBar = document.querySelector('.notification-bar');
		const sectionAnchorLinks = document.querySelector('.section-anchor-links');

		if (notificationBar && sectionAnchorLinks) {
			if (notificationBar.classList.contains('not-hidden')) {
				sectionAnchorLinks.classList.add('bar');
			} else {
				sectionAnchorLinks.classList.remove('bar');
			}
		}
	}

	// When loading the page, check the cookie
	if (Cookies.get('caw_notification_bar_closed') === 'true') {
		$('.notification-bar').removeClass('not-hidden');
		$('.notification-bar').addClass('is-hidden');
		$('.notification-bar').hide();
	} else {
		$('.notification-bar').removeClass('is-hidden');
		$('.notification-bar').addClass('not-hidden');
	}

	// Update the anchor-links class based on the initial state
	updateAnchorLinksClass();

	// When clicking the close bar button
	$('body').on('click', '.notification-bar-close', function (e) {
		e.preventDefault();
		$('.notification-bar').removeClass('not-hidden');
		$('.notification-bar').addClass('is-hidden');
		$('.notification-bar').slideUp();
		Cookies.set('caw_notification_bar_closed', 'true', { expires: 1 });

		// Update the class again
		updateAnchorLinksClass();
	});

	function updateMainPadding() {
		const main = document.querySelector('.site-main');
		const notificationBar = document.querySelector('.notification-bar');
		const sectionAnchorLinks = document.querySelector('.section-anchor-links');

		if (!main || !notificationBar) return;

		if (Cookies.get('caw_notification_bar_closed') === 'true') {
			notificationBar.classList.remove('not-hidden');
			notificationBar.classList.add('is-hidden');
			notificationBar.style.display = 'none';
		}

		// Update padding only if it is <= 991px
		if (window.innerWidth <= 991) {
			if (notificationBar.classList.contains('not-hidden')) {
				const barHeight = notificationBar.offsetHeight;
				const basePadding = 80;
				const paddingValue = `${basePadding + barHeight}px`;
				main.style.paddingTop = paddingValue;

				// Apply the same top padding to section-anchor-links if it exists
				if (sectionAnchorLinks) {
					sectionAnchorLinks.style.top = paddingValue;
				}
			} else {
				main.style.paddingTop = '80px';

				// Apply the same top value to section-anchor-links if it exists
				if (sectionAnchorLinks) {
					sectionAnchorLinks.style.top = '80px';
				}
			}
		} else {
			main.style.paddingTop = '';

			// Reset top value for section-anchor-links if it exists
			if (sectionAnchorLinks) {
				sectionAnchorLinks.style.top = '';
			}
		}
	}

	// Initial call
	updateMainPadding();

	// Update when resizing the window
	window.addEventListener('resize', updateMainPadding);

	// Also updates when closing the bar
	$('body').on('click', '.notification-bar-close', function () {
		updateMainPadding();
	});

	// And when loading the initial state
	updateMainPadding();

	// Reset search input
	$('.search-reset').on('click', function () {
		$(this).addClass('hidden');
		$(this).parent().find('.search-input').val('');
	});


	$(".services-accordion-question").on("click", function () {
		$(this).toggleClass('is-open');
	});

	$('.home-solution').on('click', function () {
		var targetSection = $('.section-tabs-light');
		if (targetSection.length === 0) {
			return; // Sair se a seção não existir
		}

		var name = $(this).find('.home-solution-name').text();
		var isMobile = $(window).width() <= 767;

		// Encontrar a tab correspondente pelo data-name (desktop)
		var targetTab = $(".service-overview-tab-link").filter(function () {
			return $(this).data("name") === name;
		});

		// Encontrar o accordion correspondente pelo texto (mobile)
		var targetAccordion = $(".services-accordion-question").filter(function () {
			return $(this).find('.services-tab-link-text').text().trim() === name.trim();
		});

		if (isMobile && targetAccordion.length > 0) {

			if (!targetAccordion.hasClass('is-open')) {
				targetAccordion.trigger('click');
			}


			setTimeout(function () {
				$('html, body').animate({
					scrollTop: targetAccordion.offset().top - 200
				}, 800);
			}, 300);

		} else {
			// Desktop: comportamento normal
			if (targetTab.length > 0) {
				targetTab.trigger('click');
			}

			// Determinar o target do scroll
			var scrollTarget;

			if (!isMobile && targetTab.length > 0) {
				// Em desktop, fazer scroll para a tab específica ou conteúdo da tab
				var tabContent = targetTab.closest('.service-overview-tab-link').next('.service-overview-tab-content');
				if (tabContent.length > 0) {
					scrollTarget = tabContent;
				} else {
					scrollTarget = targetTab;
				}
			} else {
				// Fallback para o anchor da seção
				var anchorId = targetSection.attr('id');
				scrollTarget = $('#scroll-anchor-' + anchorId);
			}

			if (scrollTarget && scrollTarget.length > 0) {
				setTimeout(function () {
					$('html, body').animate({
						scrollTop: scrollTarget.offset().top - 200
					}, 800);
				}, 100);
			}
		}
	});
});


function numberWithZero(num) {
	if (num < 10) {
		return "0" + num;
	} else {
		return num;
	}
}

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}
